// extracted by mini-css-extract-plugin
module.exports = {"tooltipBubble":"MoOAN3G8","tooltipBubbleNoMaxWidth":"qD4kdL7V","arrowIcon":"xTWJMDb6","mobileTapClose":"J_KluWHc"};